<template>
  <div class="box">
    <img :src="$cdnPath.img + 'Activity/2041/bg2.png'"/>
    <div class="box_rst box_gift">
      <template v-if="rst==0" >
        <img :src="$cdnPath.img + 'Activity/2041/box.png'" />
        <div v-for="a in 3" :class="'box_rst_choose box_rst_choose_'+a" @click="showRst(a)"></div>
      </template>
      <template v-else>
        <img :src="$cdnPath.img + 'Activity/2041/box'+rst+'.png'" />
        <div v-for="(a,index) in movies[rst]" :class="'box_rst_choose box_rst_choose_'+(index+1)" @click="goMovie(a)"></div>
      </template>
    </div>
  </div>
</template>

<script>
  import { fetch,post } from '@/api/appRequest.js';
  import API from '@/api/app.conf.js';
  export default {
    name: "index",
    data() {
      return {
        movies:['',
          [2994,1129,1133], [3492,1018,9993],[11510,6621,3662]
        ],
        fooId:11010, activityId:115,
        rst:0
      };
    },
    methods:{
      goMovie(id){
        let msg = {
          a:1,
          v:1,
          p:{mid:id+'',mtp:'1'}
        }
        this.$yymd.yy2c(JSON.stringify(msg));
      },
      showRst(a) {
        this.$dialog.loading.open('正在领取...');
        post(API.U('receive_reward'), {activity_id:115}).then(res => {
          this.$dialog.loading.close();
          if (res.status_code == 200) {
            this.$dialog.alert({mes:'恭喜成功领取1天VIP，所有图解免费看哦！快去发现好作品吧~'});
            this.rst = a;
            this.$SPM(this.fooId,this.activityId, `.${a}.1`);
          } else if (res.status_code == 805) {
            this.$dialog.notify({mes:'VIP只限领取1次！推荐几个好作品给您'});
            this.rst = a;
            this.$SPM(this.fooId,this.activityId, `.${a}.2`);
          } else if (res.status_code == 403) {
            this.$dialog.alert({
              mes: "请先登录", callback: () => {
                this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 0)
              }
            });
          } else {
            this.$dialog.alert({mes:'code:' + res.status_code + '错误' + res.message});
            this.$SPM(this.fooId,this.activityId, `.${a}.0`);
          }
        }).catch(ex=>{
          this.$dialog.loading.close();
        });
      }
    }
  }
</script>

<style rel="stylesheet/less" lang="less" scoped>
.box {
  position: relative;
  &_rst {
    position:absolute; width:80%; top:3%; left:10%;
    &_choose {
      position:absolute; width:32%; height:78%; top:20%;
      &_1 {left:2%;}
      &_2 {left:34%;}
      &_3 {left:66%;}
    }
  }
  &_gift {

  }
  img {
    width:100%;height:auto;
  }
}
</style>